import React from 'react';
import Sidebar from '../../Component/sidebar';
import { Route, Routes } from "react-router-dom";
import ManageEmployee from './manageEmployee';
import { SuperAdminSidebarData } from '../../module/superAdminSidebarData';
import PayRoll from './payroll';
import AddDepartment from './department/addDepartment';
import EditDeleteDepartment from './department/editDeleteDepartment';
import EditDeleteSubDepartment from './subDepartment/editDeleteSubDepartment';
import AddSubDepartment from './subDepartment/addSubDepartment';
import AddDesignation from './designation/addDesignation';
import EditDeleteDesignation from './designation/editDeleteDesignation';
import ActiveUsers from './activeUsers';
import SalaryAnlysis from './salaryAnalysis';
import AddPolicy from './AddPolicy';
import KRAKPI from './krakpi';
const SuperAdminDashBoard = () => {
    return (
        <>
            <div className="adminDiv d-flex">
                <Sidebar data={SuperAdminSidebarData} />
                <div className="rightSideContainer py-3 px-4">
                    <Routes>
                        <Route path="/" element={<ManageEmployee />} />
                        <Route path="manageEmployee" element={<ManageEmployee />} />
                        <Route path="payroll" element={<PayRoll />} />
                        <Route path="addDepartment" element={<AddDepartment />} />
                        <Route path="editDeleteDepartment" element={<EditDeleteDepartment />} />
                        <Route path="addSubDepartment" element={<AddSubDepartment />} />
                        <Route path="editDeleteSubDepartment" element={<EditDeleteSubDepartment />} />
                        <Route path="addDesignation" element={<AddDesignation />} />
                        <Route path="editDeleteDesignation" element={<EditDeleteDesignation />} />
                        <Route path="activeUser" element={<ActiveUsers />} />
                        <Route path="salaryAnalysis" element={<SalaryAnlysis />} />
                        <Route path="addPolicy" element={<AddPolicy />} />
                        <Route path="addKraKpi" element={<KRAKPI />} />
                    </Routes>
                </div>
            </div>
        </>
    );
};

export default SuperAdminDashBoard;
